import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {HorribleHeroesLayerConfig} from "../config/IHorribleHeroesLayerConfig";
import {TimelineLite} from "gsap";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SymbolAnimation} from "./SymbolAnimation";
import {HorribleHeroesGameConfig} from "../HorribleHeroesGameConfig";
import {HorribleHeroesReelController} from "../reel/HorribleHeroesReelController";
import {ExpandAnimation} from "./ExpandAnimation";

export class SymbolWinAnimation extends BaseView {
    private _layer: PIXI.Container;
    private _winAnimations: SymbolAnimation[][] = [];
    private thunderAnimations: SymbolAnimation[] = [];
    private overlayAnimations: ExpandAnimation[][] = [];

    constructor() {
        super();
        this._layer = StageManager.getLayer(HorribleHeroesLayerConfig.SYMBOL_WIN_ANIMATION.name);
    }

    public playSymbolWinAnimation(reel: number, symbol: number, symSize: number, withFrame: boolean = false, loop?: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                tl.pause();
                tl.kill()
            }
        });
        const sym: StateReelSymbol = Reels.getSymbol(reel, symbol)!;
        if (sym && sym.symName === "S") {
            return tl;
        }
        symSize = (symSize > 8) ? 8 : symSize;
        const winAnimation = this._winAnimations[reel][symbol];
        const position: number[] = Helper.getSymbolPositions(reel, symbol, true);
        let posY: number = position[1];

        let stckedNumber: number = 1;
        const symHeight: number = HorribleHeroesReelController.SYM_SIZE[symSize].height;
        if (sym && sym.stackedSymName!.isStacked) {
            if (sym.stackedSymName!.index < (sym.stackedSymName!.totalNum - 1)) {
                return tl;
            }
            stckedNumber = sym.stackedSymName!.totalNum;
            posY -= (symHeight * stckedNumber * 0.5 - (symHeight));
            if (stckedNumber == 3) {
                posY = posY + symHeight / 2;
            } else if (stckedNumber == 2) {
                posY = posY - 2;
            } else if (stckedNumber == 4) {
                posY = posY + symHeight;
            }
        }
        winAnimation.position.set(position[0], posY);
        this._layer.addChild(winAnimation);
        return winAnimation.playSymbolWinAnimation(symHeight, stckedNumber, withFrame, loop);
    }
    public playSymbolWinAnimationForIndiSymWin(reel: number, symbol: number, symSize: number,winWaysCont:PIXI.Container|undefined):TimelineLite{
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                tl.pause();
                tl.kill()
            }
        });
        const sym: StateReelSymbol = Reels.getSymbol(reel, symbol)!;
        if (sym && sym.symName === "S") {
            return tl;
        }
        symSize = (symSize > 8) ? 8 : symSize;
        const winAnimation = this._winAnimations[reel][symbol];
        const position: number[] = Helper.getSymbolPositions(reel, symbol, true);
        let posY: number = position[1];

        let stckedNumber: number = 1;
        const symHeight: number = HorribleHeroesReelController.SYM_SIZE[symSize].height;
        if (sym && sym.stackedSymName!.isStacked) {
            if (sym.stackedSymName!.index < (sym.stackedSymName!.totalNum - 1)) {
                return tl;
            }
            stckedNumber = sym.stackedSymName!.totalNum;
            posY -= (symHeight * stckedNumber * 0.5 - (symHeight));
            if (stckedNumber == 3) {
                posY = posY + symHeight / 2;
            } else if (stckedNumber == 2) {
                posY = posY - 2;
            } else if (stckedNumber == 4) {
                posY = posY + symHeight;
            }
        }
        winAnimation.position.set(position[0], posY);
        if(winWaysCont){
            winWaysCont.position.set(position[0], posY);
        }
        this._layer.addChild(winAnimation);
        return winAnimation.playSymbolWinAnimationForIndiSymWin(symHeight, stckedNumber);
    }

    public revealAnimation(reel: number, symbolId: number, mSize: number, reelSize: number, isInfectious: boolean, index: number, isMayhem: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite({paused: true});
        const symHeight: number = HorribleHeroesReelController.SYM_SIZE[reelSize].height;
        const winAnimation: ExpandAnimation = this.overlayAnimations[reel][index];
        winAnimation && winAnimation.setMayHemMode(isMayhem);
        tl.add(winAnimation.meltAnimation(mSize, symHeight, reelSize, isInfectious));
        const position: number[] = Helper.getSymbolPositions(reel, symbolId);
        winAnimation.anchor.set(0.5, 0.5);
        let posY: number = position[1];
        if (mSize == 2) {
            posY = HorribleHeroesGameConfig.instance.REEL_AREA_POS_Y + (symHeight * (symbolId)) + symHeight;
        } else {
            posY = HorribleHeroesGameConfig.instance.REEL_AREA_POS_Y + (symHeight * (symbolId)) + (1.5 * symHeight);
        }
        winAnimation.position.set(position[0], posY);
        this._layer.addChild(winAnimation);
        winAnimation.visible = true;
        return tl;
    }

    public playThunderAnimation(reel: number, symbolId: number, mSize: number, reelSize: number) {
        const symbolStep = HorribleHeroesReelController.SYM_SIZE[reelSize].height;
        const position: number[] = Helper.getSymbolPositions(reel, symbolId, true);
        let posY: number = HorribleHeroesGameConfig.instance.REEL_AREA_POS_Y + symbolId * symbolStep + symbolStep / 2;
        const winAnimation = this.thunderAnimations[reel];
        winAnimation.playThunderAnimation(mSize, reelSize);
        winAnimation.position.set(position[0], posY);
        this._layer.addChild(winAnimation);
        winAnimation.visible = true;
    }

    public resetAnimation(): void {
        this._winAnimations.forEach((animations: SymbolAnimation[]) => {
            animations.forEach((animation: SymbolAnimation) => {
                animation.reset();
                this._layer.removeChild(animation);
            });
        });
    }

    public resetExpandingAnimation(): void {
        this.overlayAnimations.forEach((animations: ExpandAnimation[]) => {
            animations.forEach((animation: ExpandAnimation) => {
                animation.reset();
                this._layer.removeChild(animation);
            });
        });

    }

    public resetThunder(): void {
        this.thunderAnimations.forEach((animation: SymbolAnimation) => {
            animation.resetThunder();
            this._layer.removeChild(animation);
        });
    }

    protected initAnimations(): void {
        for (let i: number = 0; i < 5; i++) {
            const symbolAnimations: SymbolAnimation[] = [];
            const overlayAnims: ExpandAnimation[] = [];
            for (let j: number = 0; j < 8; j++) {
                const symbolAnimation: SymbolAnimation = new SymbolAnimation();
                symbolAnimation.initAnimation();
                symbolAnimations.push(symbolAnimation);

            }
            for (let p: number = 0; p < 2; p++) {
                //max 2 infected syms  per reel
                const overlayAnim: ExpandAnimation = new ExpandAnimation();
                overlayAnim.initOverLayAnimations();
                overlayAnims.push(overlayAnim);
            }

            const thunderAnim: SymbolAnimation = new SymbolAnimation();
            thunderAnim.initThunderAnim();

            this.overlayAnimations.push(overlayAnims);
            this._winAnimations.push(symbolAnimations);
            this.thunderAnimations.push(thunderAnim);
        }
    }
}